<div class="modal-content">
    <div class="text-right">
      <mat-icon (click)="onSubmit(false)" style="cursor: pointer;">close</mat-icon>
    </div>
    <br>
    <div class="content">
      <form>
        <div class="note-message">
          <strong>Note:</strong> The latitude and longitude are in decimal format (e.g., -28.6139, 77.2090).
        </div>
        
        <div class="form-group d-flex align-items-center">
          <label class="col-md-3">Port Name:</label>
          <input type="text" class="form-control col-md-9" [(ngModel)]="formData.port_name" name="port_name" autocomplete="off">
        </div>
    
        <div class="form-group d-flex align-items-center">
          <label class="col-md-3">Latitude:</label>
          <input type="text" class="form-control col-md-9" [(ngModel)]="formData.latitude" name="latitude" (ngModelChange)="formData.latitude = toNumber($event)" autocomplete="off">
        </div>
    
        <div class="form-group d-flex align-items-center">
          <label class="col-md-3">Longitude:</label>
          <input type="text" class="form-control col-md-9" [(ngModel)]="formData.longitude" name="longitude" (ngModelChange)="formData.longitude = toNumber($event)" autocomplete="off">
        </div>
    <br>
        <button type="button" class="btn btn-light hover-clear clear" (click)="onSubmit(true)" >
          <span>Submit</span>
      </button>
      </form>
    </div>
    
  </div>
  